<template>
    <div>
        <div class="card-body">
            <p class="text-center aboutscroll">
                <i class="fas fa-hourglass-half"></i>&nbsp;Waiting for seller to withdraw amount.
            </p>
            <div class="card-body text-center">
                <p class="text-center aboutscroll">
                    After withdraw escrow amount the trade will be completed.
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "WithdrawPending"
    }
</script>

<style scoped>

</style>